import './styles.css'

function EditDeleteButtonsContainer({ children }) {
  return <div className='edit__delete__buttons_container pr-2'>{children}</div>
}

export default EditDeleteButtonsContainer
